import { Image } from '@plone/volto/components';
import { UniversalLink } from '@plone/volto/components';
import { Button } from 'semantic-ui-react';

import imgHeaderTramits from './img/tramits.svg';
import imgHeaderTranspa from './img/transparencia.svg';

const View = (props) => {
  const { data, mode } = props;
  const isEditMode = mode === 'edit';

  return (
    <div className='customHeader'>
      <div className="customHeader__text">
        {(data?.title) && (
              <h1 className={"customHeader__title " + data.description ? "customHeader__title--hasDesc" : "customHeader__title--noDesc"}>{data.title}</h1>
          )}
          {(data?.description) && (
              <p className="customHeader__desc">{data.description}</p>
          )}
        {data.linkUrl && (
        <p className="customHeader__link">
          <UniversalLink href={data.linkUrl} className="ui button primary">{data?.linkTitle}</UniversalLink>
        </p>
        )}
      </div>
      {data?.imageChoice === 'tramits' && (<Image className="customHeader__image d-print-none" alt="" src={imgHeaderTramits} />)}
      {data?.imageChoice === 'transparencia' && (<Image className="customHeader__image d-print-none" alt="" src={imgHeaderTranspa} />)}
    </div>
  );
};

export default View;
